"use client";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SpaceMd, SpaceLg } from "@nxt-costco-com/forge-design-tokens";
const MultiRowContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "columns"
})(({ columns }) => ({
  display: "grid",
  gridAutoRows: "auto",
  gridTemplateColumns: `repeat(${columns}, calc(100% / ${columns}))`
}));
const MultiRowItem = styled(Box, {
  shouldForwardProp: (prop) => prop !== "columns"
})(({ columns }) => ({
  [`&:nth-of-type(n+${columns + 1})`]: {
    marginBottom: 0
  },
  boxSizing: "border-box",
  marginBottom: columns === 3 ? SpaceMd : SpaceLg
}));
export {
  MultiRowContainer,
  MultiRowItem
};
